export enum EmployeeRole {
    Owner = 1,
    Employee = 2,
    Administrator = 3
}
